import { gql } from "@apollo/client";

export const GET_ANALYTICS = gql`
  query GetAnalytics {
    getAnalytics {
      orderByWeek {
        week
        total
      }
      orderByMonth {
        month
        total
      }
    }
  }
`;
